import React from "react";
import "../Styles/Podcast.css";

const podcasts = [
  {
    title: "पाठीच्या वेदना, पोश्चर आणि फिटनेस — महिलांसाठी खास उपाय!",
    link: "https://www.youtube.com/embed/S4xT0loGeec",
  },
  {
    title: "पाठीच्या वेदना, पोश्चर आणि फिटनेस — महिलांसाठी खास उपाय!",
    link: "https://www.youtube.com/embed/S4xT0loGeec",
  },
  {
    title: "पाठीच्या वेदना, पोश्चर आणि फिटनेस — महिलांसाठी खास उपाय!",
    link: "https://www.youtube.com/embed/S4xT0loGeec",
  },
   {
    title: "पाठीच्या वेदना, पोश्चर आणि फिटनेस — महिलांसाठी खास उपाय!",
    link: "https://www.youtube.com/embed/S4xT0loGeec",
  },
  {
    title: "पाठीच्या वेदना, पोश्चर आणि फिटनेस — महिलांसाठी खास उपाय!",
    link: "https://www.youtube.com/embed/S4xT0loGeec",
  },
  {
    title: "पाठीच्या वेदना, पोश्चर आणि फिटनेस — महिलांसाठी खास उपाय!",
    link: "https://www.youtube.com/embed/S4xT0loGeec",
  },
];

const Podcast = () => {
  return (
    <div className="podcast">
      <h2>Our Podcasts</h2>
      <p>Watch our latest episodes below:</p>

      <div className="video-grid">
        {podcasts.map((podcast, index) => (
          <div className="video-card" key={index}>
            <div className="video-container">
              <iframe
                src={podcast.link}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <h3 className="video-title">{podcast.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Podcast;
